import { render } from "./CustomerBookingDetailsView.vue?vue&type=template&id=900f9836&scoped=true&ts=true&lang=pug"
import script from "./CustomerBookingDetailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomerBookingDetailsView.vue?vue&type=script&setup=true&lang=ts"

import "./CustomerBookingDetailsView.vue?vue&type=style&index=0&id=900f9836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-900f9836"]])

export default __exports__